import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { AssetsTreeSearch } from 'app/containers/Assets/AssetsTree';
import { assetRoutes } from 'app/containers/Assets/AssetDetail/router';
import { createRouter } from 'app/components/LocalRouter/createRouter.js';
import Widget from 'app/components/Widget/Widget.jsx';
import { ArrowReturnBottom } from 'app/components/Icons';
import { documentTitle } from 'app/components/DocumentTitle/DocumentTitle';
import resources from 'app/store/resources';
import { postCountIsUpToDate, postChildCountIsUpToDate } from 'app/core/constants/assetCountMeta';
import classes from 'app/pages/Project/Assets/AssetList/Assets.module.scss';
import { colors } from 'app/styles/vars.js';
import AssetDetail from 'app/containers/Assets/AssetDetail/AssetDetail';
const router = createRouter('assetDetails', assetRoutes, { rightPanel: false });
const Assets = ({ match }) => {
    const { projectId } = match.params;
    const { Link, Route } = router;
    const onClickAsset = ({ metadata }) => {
        router.goTo('index', { assetId: metadata.id }, { rightPanel: false });
        resources.assets.setTreeCountAsRead(metadata.id, 'postCount');
    };
    const onSearchAsset = (assetId) => {
        router.goTo('index', { assetId }, { rightPanel: false });
    };
    const onClickBreakcrumbItem = (item) => {
        router.goTo('index', { assetId: item.id }, { rightPanel: false });
    };
    return (_jsxs("div", { className: classes.container, children: [_jsx(Widget, { className: classes.left, enableHideColumn: true, collapseTitle: "Asset list", resizable: true, optionName: "widget-assetList", defaultWidth: 300, children: _jsx(AssetsTreeSearch, { rootAssetId: projectId, assetTypes: ['ep', 'fo', 'mo', 'sh', 'gp', 'mi'], currentAssetId: router.getParam('assetId'), onClickItem: onClickAsset, allowCreate: true, onSearchAsset: onSearchAsset, resizable: true, iconColor: colors.yuzuPrimaryColor, renderLabel: (asset) => {
                        const postCount = !asset[postCountIsUpToDate] ? (_jsxs("span", { className: classes.unread, children: ["(", asset.postCount, ")"] })) : (_jsxs("span", { children: ["(", asset.postCount, ")"] }));
                        const postChildCount = !asset[postChildCountIsUpToDate] ? (_jsxs("span", { className: classes.unread, children: ["(", asset.postChildCount, ")"] })) : (_jsxs("span", { children: ["(", asset.postChildCount, ")"] }));
                        let title;
                        if (asset.attributes && asset.attributes.title) {
                            title = _jsxs("span", { children: [" - ", asset.attributes.title] });
                        }
                        return (_jsxs("div", { style: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: 'inherit',
                            }, children: [_jsxs("div", { className: classes.label, title: asset.name, children: [asset.name, title] }), _jsxs("div", { className: classes.countercontainer, children: [postCount, _jsx(ArrowReturnBottom, { width: 10, height: 15 }), postChildCount] })] }));
                    }, onOpenChild: (asset) => {
                        resources.assets.setTreeCountAsRead(asset.id, 'postChildCount');
                    } }) }), _jsx(Widget, { className: classes.right, children: router.exist() ? (_jsx(AssetDetail, { localRouter: { router, Link, Route }, breadcrumbProps: {
                        onClick: onClickBreakcrumbItem,
                        startAtAssetId: projectId,
                        enableClickItem: true,
                    }, getAsset: (asset) => asset && documentTitle(asset.name) })) : null })] }));
};
export default Assets;
